/**
 * Primary site navigation — matches legacy ISBM menu structure.
 * Hash links scroll to section ids on the target page.
 */
export const PRIMARY_NAV = [
  { to: '/', label: 'Home', end: true },
  {
    label: 'CFP',
    to: '/call-for-papers',
    children: [
      { to: '/call-for-papers#paper', label: 'Call for Paper' },
      { to: '/call-for-papers#dates', label: 'Important Dates' },
      { to: '/call-for-papers#guidelines', label: 'Submission Guidelines' },
      { to: '/call-for-papers#tracks', label: 'Conference Tracks' },
      { to: '/call-for-papers#indexing', label: 'Publication & Indexing' },
      { to: '/call-for-papers#downloads', label: 'Important Downloads' },
    ],
  },
  { to: '/publications', label: 'Publication' },
  {
    label: 'Committee',
    to: '/committees',
    children: [
      { to: '/committees#international-conference-chairs', label: 'International Conference Chairs' },
      { to: '/committees#local-organising-chair', label: 'Local Partner Chair' },
      { to: '/committees#technical-programme-committee-chair', label: 'Technical Programme Committee Chair' },
      { to: '/committees#event-secretaries', label: 'Event Secretaries' },
      { to: '/committees#technical-program-committee', label: 'Technical Program Committee' },
      { to: '/join-us', label: 'Join Us' },
    ],
  },
  { to: '/speakers', label: 'Speakers' },
  { to: '/agenda', label: 'Agenda' },
  { to: '/gallery', label: 'Gallery' },
  {
    label: 'Venue',
    to: '/venue',
    children: [
      { to: '/venue#venue', label: 'Venue' },
      { to: '/venue#transportation', label: 'Transportation' },
      { to: '/venue#visa', label: 'Visa' },
      { to: '/venue#explore-bangkok', label: 'Explore Bangkok' },
    ],
  },
  { to: '/contact-us', label: 'Contact Us' },
];

export const FOOTER_COLUMNS = [
  {
    title: 'GRS Global Ecosystem',
    openInNewTab: true,
    links: [
      { to: 'https://www.gr-conferences.com/', label: 'GR Conferences' },
      { to: 'https://gr-journals.com/', label: 'GR Journals' },
      { to: 'https://www.gr-connect.org/', label: 'GR Connect' },
      { to: 'https://gr-connect.org/gr-quotient', label: 'GR Quotient' },
      { to: 'https://gr-journals.com/author-services', label: 'GR Author Services' },
      { to: 'https://grsglobal.org/chronicle/', label: 'GR Chronicle' },
    ],
  },
  {
    title: 'Conference',
    links: [
      { to: '/', label: 'Home' },
      { to: '/call-for-papers', label: 'CFP' },
      { to: '/registration', label: 'Registration' },
      { to: '/venue', label: 'Venue' },
      { to: '/contact-us', label: 'Contact Us' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { to: '/speakers', label: 'Speakers' },
      { to: '/gallery', label: 'Gallery' },
      { to: '/publications', label: 'Publications' },
      { to: '/zoom-link', label: 'Zoom Links' },
      { to: '/join-us', label: 'Join Us' },
      { to: '/feedback', label: 'Feedback' },
    ],
  },
  {
    title: 'Support',
    links: [
      { to: '/contact-us', label: 'Contact Us' },
      { to: '/feedback', label: 'Feedback' },
      { to: '/legal-information', label: 'Legal Information' },
      { to: '/terms-and-conditions', label: 'Terms & Conditions' },
    ],
  },
];

/** Split `to` into pathname + hash for active-state checks. */
export function splitNavTo(to) {
  const [pathname, hash = ''] = to.split('#');
  return { pathname, hash: hash ? `#${hash}` : '' };
}

const DIRECT_FILE_EXTENSIONS = /\.(pdf|zip|doc|docx|xls|xlsx)$/i;

/** Static assets and external URLs must use native `<a href>` — not React Router. */
export function isDirectFileLink(to) {
  if (!to || typeof to !== 'string') return false;
  if (/^(https?:|mailto:|tel:)/.test(to)) return true;
  const { pathname } = splitNavTo(to);
  return pathname.startsWith('/download/') || DIRECT_FILE_EXTENSIONS.test(pathname);
}

export function isNavLinkActive(to, { pathname, hash }) {
  const { pathname: path, hash: linkHash } = splitNavTo(to);
  const onPage =
    pathname === path ||
    pathname.startsWith(`${path}/`) ||
    (path === '/call-for-papers' && pathname === '/cfp');

  if (linkHash) {
    return onPage && hash === linkHash;
  }
  if (path === '/') {
    return pathname === '/' && !hash;
  }
  if (path === '/call-for-papers') {
    return onPage && !hash;
  }
  return onPage && !hash;
}

export function isNavGroupActive(item, location) {
  if (!item.children) return false;
  if (item.label === 'CFP' && (location.pathname === '/call-for-papers' || location.pathname === '/cfp')) {
    return true;
  }
  if (item.label === 'Committee' && (location.pathname === '/committees' || location.pathname === '/join-us')) {
    return true;
  }
  if (item.label === 'Venue' && location.pathname === '/venue') {
    return true;
  }
  return item.children.some((c) => isNavLinkActive(c.to, location));
}
